import React, { useCallback, useEffect, useState } from 'react';
import { debounce } from 'lodash';
import { DefaultValues, useForm } from 'react-hook-form';

type LanguageFilterFormValues = {
	languages?: string[];
};

export const useLanguageFilter = (p0?: string[]) => {
	const cleanInitial = (p0 || []).filter(Boolean) as string[];

	const [languages, setLanguages] = useState<string[]>(cleanInitial);

	const defaultValues: DefaultValues<LanguageFilterFormValues> = {
		languages: cleanInitial,
	};

	const { register, getValues, control, watch, setValue } = useForm({
		defaultValues,
	});
	const filter = watch('languages');
	const debouncedUpdate = useCallback(
		debounce((list?: string[]) => {
			setLanguages(list || []);
		}, 300),
		[]
	);

	useEffect(() => {
		const cleanFilter = (filter || []).filter(Boolean) as string[];
		debouncedUpdate(cleanFilter);
	}, [filter, debouncedUpdate]);

	return {
		register,
		getValues,
		control,
		languages,
	};
};
